import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { SettingsGroup, SettingsReadOnlyField } from '@/features/settings'
import { useAppSelector } from '@/redux/hooks'
import { selectEmail, selectFullName } from '@/redux/me/meSlice'

export const AccountInformationSection = () => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const fullName = useAppSelector(selectFullName)
  const email = useAppSelector(selectEmail)

  return (
    <SettingsGroup
      colorScheme={colorScheme}
      title={t('settings:rebrand_account_info_group_title')}
    >
      <SettingsReadOnlyField
        colorScheme={colorScheme}
        dataTestId='settingsPage_accountInformation_name'
        label={t('settings:rebrand_account_name_label')}
        value={fullName}
      />
      <SettingsReadOnlyField
        colorScheme={colorScheme}
        dataTestId='settingsPage_accountInformation_email'
        label={t('settings:rebrand_account_email_label')}
        value={email ?? ''}
      />
    </SettingsGroup>
  )
}
